<!-- 首页 -->
<template>
  <div class="e_solve">
    <div class="styleBox_05">
      <div class="tipsBoxWall">
        <ul class="tipsBox">
          <li
            v-for="(items,keys) in solveArr"
            :key="keys"
            :class="items.tagsChecked ? 'checked' : ''"
            @click="changeTags(keys)"
            :style="viewWidth >= 1024 ? (solveArr.length <= 5 ? 'maxWidth:' +  1180 / solveArr.length + 'px' : 'minWidth:' + 1180 / 5 + 'px' ) : ('minWidth:' + viewWidth / 3 + 'px')"
          >
            <p class="tipNum">0{{ keys + 1}}</p>
            <span>
              <a href="javascript:;" :title="items.title">{{ items.title }}</a>
            </span>
          </li>
        </ul>
      </div>
      <div
        v-for="(items,keys) in solveArr"
        :key="keys"
        v-show="items.tagsChecked"
        :class="items.tagsChecked ? 'animate__animated animate__fadeInLeft' : ''"
      >
        <!-- <div v-html="items.content"></div> -->
        <div class="tipsInner">
          <div class="tipsInnerWidth">
            <div class="tipInnerImg">
              <img :src="items.coverImage" />
            </div>
            <div class="tipInnerText">
              <h4>{{ items.title }}</h4>
              <div class="icon_01"></div>
              <p>{{ items.descriptionStr }}</p>
              <ul>
                <li v-for="itemi in items.descriptionArr" :key="itemi">{{ itemi }}</li>
              </ul>
              <div class="btnBox">
                <a href="javascript:void(0);" class="comButton collection-1 btn-15">
                  <span @click="toSolveInfo(items)">Learn more →</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="numberTips">
        <span
          v-for="(items,keys) in solveArr"
          :key="keys"
          :class="items.tagsChecked ? 'spanCheck':''"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      solveArr: [],
      baseImgUrl: '',
      viewWidth: '' // 屏幕宽度
    }
  },
  methods: {
    getSolveList () {
      this.solveArr.forEach(items => {
        items.tagsChecked = false
        // items.path = item.path
        if (items.description && (items.description.indexOf('@') !== -1)) {
          let arr = items.description.split('@')
          items.descriptionStr = arr[0]
          arr.shift()
          items.descriptionArr = arr
        }
      })
      this.solveArr[0].tagsChecked = true
      console.log(this.solveArr)
    },
    // 当窗口宽度发生改变
    changeViewWidth () {
      this.viewWidth = document.documentElement.clientWidth || document.body.clientWidth
    },
    // 解决方案 点击
    changeTags (indexs) {
      let arr = JSON.parse(JSON.stringify(this.solveArr))
      arr.forEach(item => {
        item.tagsChecked = false
      })
      arr[indexs].tagsChecked = true
      this.solveArr = JSON.parse(JSON.stringify(arr))
    }
  },
  created () {
    this.viewWidth = document.documentElement.clientWidth || document.body.clientWidth
    this.baseImgUrl = this.$axios.defaults.baseURL
    this.solveArr = [
      {
        'id': 53,
        'createTime': '2023-01-12 18:36:35',
        'updateTime': '2023-01-12 18:36:35',
        'title': 'Internet APP',
        'subtitle': 'Internet APP',
        'userId': 1,
        'author': null,
        'coverImage': this.baseImgUrl + '/u/20230408/互联网app 768x768_1680939590762.png',
        'qrcodePath': null,
        'isMarkdown': true,
        'top': 0,
        'categoryId': 3,
        'status': 1,
        'recommended': 0,
        'slider': 0,
        'sliderImg': this.baseImgUrl + '/u/20230131/c28e463517f656c8f73e436a2118ff34_1675144132411.jpg',
        'menuImg': this.baseImgUrl + '/u/20230131/app_1675163499342.png',
        'original': 1,
        'charge': 0,
        'sort': 1,
        'description': 'Incorporate the online business platform into high-quality network as a service (NaaS) to ensure the security and speed of the business platform, and prevent all malicious traffic attacks and infiltration theft. User APPs utilize their nearby access nodes to provide stable and high-quality access without awareness and have a smooth use experience. It can also cooperate with risk equipment queries to conduct security checks on users login identities, creating a healthy usage atmosphere for users. \r\n@network performance\r\n@network security\r\n@Mobile security\r\n@Omnidirectional situational awareness',
        'keywords': null,
        'comment': 1,
        'lookCount': 0,
        'commentCount': 0,
        'loveCount': 0,
        'newFlag': 0,
        'tags': [],
        'bizCategory': null,
        'path': null
      },
      {
        'id': 33,
        'createTime': '2023-01-02 15:17:41',
        'updateTime': '2023-01-02 15:17:41',
        'title': 'Enterprise Remote Office Access',
        'subtitle': '',
        'userId': 1,
        'author': null,
        'coverImage': this.baseImgUrl + '/u/20230408/远程办公768x768_1680939612254.png',
        'qrcodePath': null,
        'isMarkdown': true,
        'categoryId': 3,
        'status': 1,
        'recommended': 0,
        'slider': 0,
        'sliderImg': this.baseImgUrl + '/u/20230102/编组@2x_1672643856627.png',
        'menuImg': this.baseImgUrl + '/u/20230131/远程-01_1675163519246.png',
        'original': 1,
        'charge': 0,
        'sort': 2,
        'description': 'Quickly establish a new boundary for enterprise security, break away from traditional network architectures, adopt a zero trust strategy to replace VPN connections, and grant access rights based on user identities, geographical locations, terminal device status, and other contexts, helping employees work safely anytime, anywhere. Establish a new enterprise security boundary composed of trusted people, trusted terminals, and trusted devices.\r\n@Zero Trust Security\r\n@Activity audit\r\n@Private network performance\r\n@Applying Differential Segments',
        'keywords': null,
        'comment': 1,
        'lookCount': 0,
        'commentCount': 0,
        'loveCount': 0,
        'newFlag': 0,
        'tags': [
          {
            'id': 11,
            'createTime': '2023-01-02 11:05:29',
            'updateTime': '2023-01-11 20:25:49',
            'name': 'homeTabs',
            'description': '首页切换一栏'
          }
        ],
        'bizCategory': null,
        'path': null
      },
      {
        'id': 56,
        'createTime': '2023-01-12 19:08:33',
        'updateTime': '2023-01-12 19:08:33',
        'title': 'Shield Mobile Application Stealth',
        'subtitle': '',
        'userId': 1,
        'author': null,
        'coverImage': this.baseImgUrl + '/u/20230408/等保合规 768x768_1680939552034.png',
        'qrcodePath': null,
        'isMarkdown': true,
        'top': 0,
        'categoryId': 3,
        'status': 1,
        'recommended': 0,
        'slider': 0,
        'sliderImg': '',
        'menuImg': this.baseImgUrl + '/u/20230131/保护_1675163542723.png',
        'original': 1,
        'charge': 0,
        'sort': 5,
        'description': 'Through network as a service (NaaS) access, the business platform is placed under the protection of high-quality network services, covering scenarios such as internal network business access, external network application access, and remote security operation and maintenance. It can not only prevent red party penetration attacks, but also withstand T-level DDOS attacks and immune CC. And ensure that users of the business platform have access to the nearest network, enabling them to access the most quickly, conveniently, and safely regardless of where they are located. It can avoid risks on key information, improve the security technology architecture and technical force, make diverse hacker attacks inaccessible and in-depth to the source station, protect the security of confidential information and ensure the quality of service, and ensure uninterrupted business during network protection operations.\r\n@Apply stealth\r\n@Integrated protection closed-loop\r\n@Ultimate office experience\r\n@Full channel control',
        'keywords': null,
        'comment': 1,
        'lookCount': 0,
        'commentCount': 0,
        'loveCount': 0,
        'newFlag': 0,
        'tags': [
          {
            'id': 11,
            'createTime': '2023-01-02 11:05:29',
            'updateTime': '2023-01-11 20:25:49',
            'name': 'homeTabs',
            'description': '首页切换一栏'
          }
        ],
        'bizCategory': null,
        'path': null
      },
      {
        'id': 61,
        'createTime': '2023-01-28 12:02:27',
        'updateTime': '2023-01-28 12:02:27',
        'title': 'Enterprise multi branch networking',
        'subtitle': '',
        'userId': 1,
        'author': null,
        'coverImage': this.baseImgUrl + '/u/20230408/供应链 768x768_1680939572786.png',
        'qrcodePath': null,
        'isMarkdown': true,
        'top': 0,
        'categoryId': 3,
        'status': 1,
        'recommended': 0,
        'slider': 0,
        'sliderImg': '',
        'menuImg': this.baseImgUrl + '/u/20230131/代码,分支,分流,分叉_1675163554330.png',
        'original': 1,
        'charge': 0,
        'sort': 6,
        'description': 'With high-quality virtual private networks covering the world, enterprise users can quickly build private network connections and achieve real-time interoperability among multiple branches by deploying intelligent access gateways to access the MagNet global network. Autonomous online opening, rapid deployment, significantly improving networking efficiency and reducing networking costs. At the same time, it can provide more flexible WAN access methods based on different users, and provide online dynamic network bandwidth adjustment based on the usage of each node, allowing users to manage their own networks more intelligently.\r\n@Apply stealth\r\n@Integrated protection closed-loop\r\n@Ultimate office experience\r\n@Full channel control\r\n',
        'keywords': null,
        'comment': 1,
        'lookCount': 0,
        'commentCount': 0,
        'loveCount': 0,
        'newFlag': 0,
        'tags': [
          {
            'id': 11,
            'createTime': '2023-01-02 11:05:29',
            'updateTime': '2023-01-11 20:25:49',
            'name': 'homeTabs',
            'description': '首页切换一栏'
          }
        ],
        'bizCategory': null,
        'path': null
      },
      {
        'id': 65,
        'createTime': '2023-01-28 16:03:34',
        'updateTime': '2023-01-28 16:03:34',
        'title': 'Global application acceleration',
        'subtitle': '',
        'userId': 1,
        'author': null,
        'coverImage': this.baseImgUrl + '/u/20230408/重保 768x768_1680939629569.png',
        'qrcodePath': null,
        'isMarkdown': true,
        'top': 0,
        'categoryId': 3,
        'status': 1,
        'recommended': 0,
        'slider': 0,
        'sliderImg': '',
        'menuImg': this.baseImgUrl + '/u/20230131/加速_1675163587531.png',
        'original': 1,
        'charge': 0,
        'sort': 7,
        'description': 'Application acceleration solutions based on software defined networks, jointly built by operators, can provide users with intelligent acceleration services and achieve high-speed access to global applications. Users in different regions can install MagEdge in their offices or mobile terminals, access the MagNet global network nearby, and access the application server directly through high-speed dedicated channels, thereby improving the quality of application access.\r\n@High quality virtual private network\r\n@high reliability\r\n@Suitable for multiple scenarios\r\n@Increased access speed',
        'keywords': null,
        'comment': 1,
        'lookCount': 0,
        'commentCount': 0,
        'loveCount': 0,
        'newFlag': 0,
        'tags': [
          {
            'id': 11,
            'createTime': '2023-01-02 11:05:29',
            'updateTime': '2023-01-11 20:25:49',
            'name': 'homeTabs',
            'description': '首页切换一栏'
          }
        ],
        'bizCategory': null,
        'path': null
      },
      {
        'id': 67,
        'createTime': '2023-01-28 16:04:06',
        'updateTime': '2023-01-28 16:04:06',
        'title': 'Multi Cloud Interconnection',
        'subtitle': '',
        'userId': 1,
        'author': null,
        'coverImage': this.baseImgUrl + '/u/20230328/未标题-3_1680008581202.jpg',
        'qrcodePath': null,
        'isMarkdown': true,
        'top': 0,
        'categoryId': 3,
        'status': 1,
        'recommended': 0,
        'slider': 0,
        'sliderImg': '',
        'menuImg': this.baseImgUrl + '/u/20230131/云端,云服务_1675163789206.png',
        'original': 1,
        'charge': 0,
        'sort': 7,
        'description': 'Through the high-speed cloud access channel, combined with the MagNet global network, it helps users quickly achieve high-speed direct connectivity between VPCs of various public clouds, and achieve rapid mutual access, secure transmission, and unified management and control between different public clouds or different regions of the same public cloud. It is suitable for a hybrid cloud architecture between data centers and public clouds, disaster recovery backup between multiple public clouds, high-speed access to cloud resources through office networks, and other business scenarios.\r\n@Multi Cloud Fusion\r\n@Failover\r\n@One button activation\r\n@Intelligent routing\r\n',
        'keywords': null,
        'comment': 1,
        'lookCount': 0,
        'commentCount': 0,
        'loveCount': 0,
        'newFlag': 0,
        'tags': [
          {
            'id': 11,
            'createTime': '2023-01-02 11:05:29',
            'updateTime': '2023-01-11 20:25:49',
            'name': 'homeTabs',
            'description': '首页切换一栏'
          }
        ],
        'bizCategory': null,
        'path': null
      },
      {
        'id': 34,
        'createTime': '2023-01-02 15:17:59',
        'updateTime': '2023-01-02 15:17:59',
        'title': 'Mobile Internet and other security compliance',
        'subtitle': '',
        'userId': 1,
        'author': null,
        'coverImage': this.baseImgUrl + '/u/20230328/未标题-2_1680008618774.jpg',
        'qrcodePath': null,
        'isMarkdown': true,
        'top': 0,
        'categoryId': 3,
        'status': 1,
        'recommended': 0,
        'slider': 0,
        'sliderImg': this.baseImgUrl + '/u/20230102/编组@2x_1672643875404.png',
        'menuImg': this.baseImgUrl + '/u/20230131/互联网汇聚_1675163652017.png',
        'original': 1,
        'charge': 0,
        'sort': 8,
        'description': 'By identifying and evaluating the security vulnerabilities, severity of security vulnerabilities, and effectiveness of security control measures for mobile terminals and personal applications, we can identify and qualitatively assess the information security risks faced by important information systems, and meet the Level III (IV) standard of Equal Protection 2.0. This enables enterprises to easily meet industry regulatory requirements while improving their own risk management and security assurance capabilities.\r\n@Mobile terminal unified control\r\n@Mobile terminal threat real-time monitoring and protection\r\n@Unified security compliance checks\r\n@Enterprise’s own business security',
        'keywords': null,
        'comment': 1,
        'lookCount': 0,
        'commentCount': 0,
        'loveCount': 0,
        'newFlag': 0,
        'tags': [
          {
            'id': 11,
            'createTime': '2023-01-02 11:05:29',
            'updateTime': '2023-01-11 20:25:49',
            'name': 'homeTabs',
            'description': '首页切换一栏'
          }
        ],
        'bizCategory': null,
        'path': null
      },
      {
        'id': 66,
        'createTime': '2023-01-28 16:03:51',
        'updateTime': '2023-01-28 16:03:51',
        'title': 'Disaster Recovery Management',
        'subtitle': '',
        'userId': 1,
        'author': null,
        'coverImage': this.baseImgUrl + '/u/20230128/容灾2-768x768_1674893492166.jpg',
        'qrcodePath': null,
        'isMarkdown': true,
        'top': 0,
        'categoryId': 3,
        'status': 1,
        'recommended': 0,
        'slider': 0,
        'sliderImg': '',
        'menuImg': this.baseImgUrl + '/u/20230131/18火灾自动报警_1675163601355.png',
        'original': 1,
        'charge': 0,
        'sort': 8,
        'description': 'Utilize the latest software definition WAN technology to realize the virtualization of WAN resources. Through in-depth cooperation with mainstream cloud vendors/data centers at home and abroad, achieve seamless scheduling of network resources, help users achieve fast, on-demand, reliable, and secure transmission of data on the cloud/data center, achieve visual management of business through their own control platform, and simplify customer operation and maintenance investment. Through the integration of wide area network technology, it helps enterprise users achieve flexible business access and intelligent management during the digital transformation process.\r\n@High quality virtual private network\r\n@high reliability\r\n@data security\r\n@Visual management platform',
        'keywords': null,
        'comment': 1,
        'lookCount': 0,
        'commentCount': 0,
        'loveCount': 0,
        'newFlag': 0,
        'tags': [
          {
            'id': 11,
            'createTime': '2023-01-02 11:05:29',
            'updateTime': '2023-01-11 20:25:49',
            'name': 'homeTabs',
            'description': '首页切换一栏'
          }
        ],
        'bizCategory': null,
        'path': null
      },
      {
        'id': 55,
        'createTime': '2023-01-12 19:08:16',
        'updateTime': '2023-01-12 19:08:16',
        'title': 'Supply Chain Area Security',
        'subtitle': '',
        'userId': 1,
        'author': null,
        'coverImage': this.baseImgUrl + '/u/20230128/多云互联-768x768_1674893506293.jpg',
        'qrcodePath': null,
        'isMarkdown': true,
        'top': 0,
        'categoryId': 3,
        'status': 1,
        'recommended': 0,
        'slider': 0,
        'sliderImg': '',
        'menuImg': this.baseImgUrl + '/u/20230131/安全_1675163667753.png',
        'original': 1,
        'charge': 0,
        'sort': 9,
        'description': 'Identify and qualitatively assess information security risks faced by important information systems by identifying and evaluating security vulnerabilities, severity of security vulnerabilities, and effectiveness of security control measures for terminals and applications. While integrating various security capabilities, data is displayed in the dimensions of "person", "application", "terminal", "network", and "source", filtering malicious traffic, providing proactive security protection for business platforms, greatly improving enterprise security visibility, and providing a comprehensive view of the security situation. The terminal must meet the security baseline to allow access to the open ports of the business platform, monitor the status of terminal equipment in real-time, and protect the security of enterprise IT supply chain assets.\r\n@Supply Chain Border Security\r\n@未知风险主动防御\r\n@Active defense against unknown risks\r\n@Improve security posture visibility',
        'keywords': null,
        'comment': 1,
        'lookCount': 0,
        'commentCount': 0,
        'loveCount': 0,
        'newFlag': 0,
        'tags': [
          {
            'id': 11,
            'createTime': '2023-01-02 11:05:29',
            'updateTime': '2023-01-11 20:25:49',
            'name': 'homeTabs',
            'description': '首页切换一栏'
          }
        ],
        'bizCategory': null,
        'path': null
      }
    ]
    this.getSolveList()
  },
  mounted () {
    window.onresize = () => {
      this.imgLoad()
      this.changeViewWidth()
    }
  },
  computed: {
  }
}
</script>
<style lang="less" scoped>
// 移动端样式
@media only screen and (max-width: 1024px) {
  .styleBox_05 {
    width: 100%;
  // 按钮样式
    .comButton {
      padding: 0.9375rem 2.25rem;
      color: #fff;
      border-radius: 1.75rem;
      cursor: pointer;
      overflow: hidden;
      background-image: linear-gradient(228deg, #3ee3ff, #2e9efd 41%, #186ae8);
      height: 3.125rem;
      font-size: 0.7rem;
    }
    .moreService {
      text-align: center;
    }
    .btn-15:after {
      background-image: linear-gradient(315deg, #0027c2 0, #209dff 74%);
    }
    .tipsBox {
      box-shadow: 0px 4px 8px -3px rgba(0, 0, 0, 0.3);
      // height: 6.25rem;
      display: flex;
      position: relative;
      z-index: 9;
      overflow-x: scroll;
      width: 100%;
      overflow-x: scroll;
      li {
        width: 33.3%;
        font-size: 0.875rem;
        font-weight: bold;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        cursor: pointer;
        flex: 1;
        padding: 0.75rem 1.56rem;
        line-height: 1.6rem;
        .tipNum {
          color: #90bff7;
          font-size: 1rem;
        }
      }
      .checked {
        background-image: linear-gradient(
          228deg,
          rgba(62, 227, 255, 1),
          rgba(46, 158, 253, 1) 62%,
          rgba(24, 106, 232, 1)
        );
        color: #fff;
      }
    }
    .numberTips {
      display: flex;
      justify-content: center;
      span {
        width: 1.5rem;
        height: 0.25rem;
        border-radius: 0.125rem;
        background: #d6dfed;
        margin-right: 0.5rem;
        margin-top: 1.43rem;
      }
      span:last-child {
        margin-right: 0;
      }
      .spanCheck {
        background: #428bf8;
      }
    }
  }
}
// pc端样式
@media only screen and (min-width: 1024px){
  .styleBox_05 {
      width: 100%;
      .comButton {
        padding: 15px 36px;
        color: #fff;
        border-radius: 28px;
        cursor: pointer;
        overflow: hidden;
        background-image: linear-gradient(228deg, #3ee3ff, #2e9efd 41%, #186ae8);
        height: 50px;
      }
      .btn-15:after {
        background-image: linear-gradient(315deg, #0027c2 0, #209dff 74%);
      }
      .tipsBoxWall {
        box-shadow: 0px 4px 8px -3px rgba(0, 0, 0, 0.3);
        height: 90px;
        position: relative;
        z-index: 9;
      }
      .tipsBox {
        display: flex;
        max-width: 1180px;
        overflow-x: scroll;
        margin: 0 auto;
        outline: none;
        height: 100%;
        scrollbar-color: rgb(205, 205, 205);
        scrollbar-width: thin;
        -ms-overflow-style: none;
        li {
          padding: 19px 16px;
          font-size: 19px;
          font-weight: bold;
          display: flex;
          align-items: center;
          cursor: pointer;
          span{
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
          }
          .tipNum {
            color: #90bff7;
            font-size: 30px;
            margin-right: 12px;
          }
        }
        .checked {
          background-image: linear-gradient(
            228deg,
            rgba(62, 227, 255, 1),
            rgba(46, 158, 253, 1) 62%,
            rgba(24, 106, 232, 1)
          );
          color: #fff;
        }
      }
      .tipsBox::-webkit-scrollbar {
        width: 20px;
        height: 6px;
      }
      .tipsBox::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: rgb(205, 205, 205);
      }
      .tipsBox::-webkit-scrollbar-button {
        width: 0;
        border-radius: 50%;
        background: black;
      }
      .tipsBox::-webkit-scrollbar-track {
        // box-shadow: inset 0 0 2px #333;
        border-radius: 5px;
        background: rgba(0, 0, 0, 0);
      }
      .tipsBox::-webkit-scrollbar-corner {
        background: springgreen;
      }
      .tipInnerText{
        p{
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 7;
        }
      }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/comForPc/English_model/E_solve.vue